function joinClassNames(...values) {
  return values.filter(Boolean).join(" ");
}

export default function MobilePage({
  header,
  children,
  hasStickyActions = false,
  className = "",
  contentClassName = "",
  mainProps = {},
}) {
  const { className: mainClassName = "", ...restMainProps } = mainProps;

  // Composition invariant: MobilePage is a standalone V2 page shell that owns
  // both the 100dvh canvas and its gutter. A V2 route already rendered inside
  // MainLayout must use DesignV2Scope + page content directly so MainLayout
  // remains the sole owner of those two responsibilities.

  return (
    <div
      className={joinClassNames(
        "lz-v2-mobile-page",
        hasStickyActions && "lz-v2-mobile-page--with-sticky-actions",
        className
      )}
    >
      {header ? <header className="lz-v2-mobile-page__header">{header}</header> : null}
      <main
        {...restMainProps}
        className={joinClassNames("lz-v2-mobile-page__main", mainClassName)}
      >
        <div className={joinClassNames("lz-v2-mobile-page__content", contentClassName)}>
          {children}
        </div>
      </main>
    </div>
  );
}
